(function () {
  function cartUpdateUrl() {
    if (window.Shopify && Shopify.routes && Shopify.routes.root) {
      return Shopify.routes.root + 'cart/update.js';
    }
    return '/cart/update.js';
  }

  function cartUrl() {
    return window.theme && theme.routes_cart_url ? theme.routes_cart_url : '/cart';
  }

  function lineKey(row) {
    return row && row.getAttribute('data-product-id');
  }

  function bundleId(row) {
    return row && row.getAttribute('data-bundle-id');
  }

  function isParent(row) {
    return row && row.getAttribute('data-bundle-parent') !== 'false';
  }

  function rowsForBundle(id) {
    if (!id) return [];
    return Array.prototype.slice.call(
      document.querySelectorAll('.cart-table [data-bundle-id="' + CSS.escape(id) + '"]')
    );
  }

  function inputForRow(row) {
    return row && row.querySelector('.item-qty');
  }

  function currentQuantity(row) {
    var input = inputForRow(row);
    var value = input ? Number(input.value) : 1;
    return Number.isFinite(value) && value > 0 ? Math.floor(value) : 0;
  }

  function maxQuantity(row) {
    var input = inputForRow(row);
    var max = input && input.getAttribute('max');
    return max ? Number(max) : null;
  }

  function clampQuantity(row, quantity) {
    var max = maxQuantity(row);
    var next = Math.max(0, Math.floor(Number(quantity) || 0));
    if (max != null && Number.isFinite(max)) return Math.min(next, max);
    return next;
  }

  function setBusy(active) {
    var busy = document.getElementById('ajaxBusy');
    if (busy) busy.style.display = active ? 'block' : 'none';
  }

  function reloadCart() {
    window.location.href = cartUrl();
  }

  function updateBundle(id, quantity) {
    var updates = {};
    rowsForBundle(id).forEach(function (row) {
      var key = lineKey(row);
      if (key) updates[key] = quantity;
    });
    if (Object.keys(updates).length === 0) return;

    setBusy(true);
    fetch(cartUpdateUrl(), {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ updates: updates })
    }).then(function (response) {
      if (!response.ok) throw new Error('Could not update bundle.');
      return response.json();
    }).then(reloadCart).catch(function (error) {
      setBusy(false);
      console.error(error);
    });
  }

  function lockChildRows() {
    document.querySelectorAll('.cart-table [data-bundle-parent="false"]').forEach(function (row) {
      row.querySelectorAll('.qtybtn, .remove_item_multi').forEach(function (button) {
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
      });
      var input = inputForRow(row);
      if (input) {
        input.disabled = true;
        input.readOnly = true;
        input.setAttribute('aria-disabled', 'true');
      }
    });
  }

  function handledParentButton(button) {
    var row = button.closest('.item[data-bundle-id]');
    if (!row || !isParent(row)) return false;
    var id = bundleId(row);
    var next = currentQuantity(row);

    if (button.classList.contains('remove_item_multi')) {
      next = 0;
    } else if (button.classList.contains('qtyplus_multi')) {
      next = clampQuantity(row, next + 1);
    } else if (button.classList.contains('qtyminus_multi')) {
      next = clampQuantity(row, next - 1);
    } else {
      return false;
    }

    updateBundle(id, next);
    return true;
  }

  function boot() {
    lockChildRows();

    document.addEventListener('click', function (event) {
      var button = event.target.closest('.cart-table .qtybtn');
      if (!button) return;
      var row = button.closest('.item[data-bundle-id]');
      if (row && !isParent(row)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      if (handledParentButton(button)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);

    document.addEventListener('change', function (event) {
      var input = event.target.closest('.cart-table .item[data-bundle-id] .item-qty');
      if (!input) return;
      var row = input.closest('.item[data-bundle-id]');
      if (!isParent(row)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      event.preventDefault();
      event.stopImmediatePropagation();
      updateBundle(bundleId(row), clampQuantity(row, input.value));
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
